import { createFileRoute } from "@tanstack/react-router";

import { LoginForm } from "@/features/auth/ui";

export const Route = createFileRoute("/_public/login")({
  component: LoginPage,
});

function LoginPage() {
  return (
    <div className="flex min-h-full w-full items-center justify-center overflow-y-hidden p-6 md:p-10">
      <div className="w-full max-w-sm">
        <LoginForm />
      </div>
    </div>
  );
}
